import { differenceInSeconds } from "date-fns";
// import statusTrueIcon from "../assets/icons/bigStatusTrue.png";
import statusTrueIcon from "../assets/icons/bancaribe/bigStatusTrue.svg";

import statusFalseIcon from "../assets/icons/bigStatusFalse.png";
import themeConfig from "../config";
/**
 * Encode data to url
 * @param {object} data - Object with data
 * @returns string with all data
 */
function encodeQueryData(data) {
  let result = [];
  for (let ele in data) {
    result.push(encodeURIComponent(ele) + "=" + encodeURIComponent(data[ele]));
  }
  return result.join("&");
}

/**
 * Builder of url with params for list of data
 * @param {string} field - Name of the field
 * @param {string} filter - Value of field
 * @param {string} groupby - Text with values to group
 * @param {string} quickFilter - Value for filter by time
 * @returns string with filters
 */
function buildFilter(field, filter, groupby, quickFilter) {
  let searchby = field === undefined ? "" : field;
  let search = filter === undefined ? "" : filter;
  let filters = {
    groupby: groupby === undefined ? "" : groupby,
    orderby: groupby === undefined ? "" : groupby,
    params:
      quickFilter === undefined ||
      quickFilter === "Quick filter" ||
      quickFilter === "All times" ||
      quickFilter === "Filtro rapido" ||
      quickFilter === "Todo"
        ? ""
        : quickFilter,
  };

  let filtersToText = `${searchby}${searchby === "" ? "" : "&"}${search}${
    search === "" ? "" : "&"
  }${encodeQueryData(filters)}`;
  return filtersToText;
}

/**
 * Format values for filters
 * @param {object} values - values with filters
 * @returns object with fields and filters
 */
function formatFilters(values) {
  let fields = "";
  let filters = "";
  let subFields = "";
  let subFilters = "";
  delete values.filterField;
  delete values.filters;
  delete values.filtersBy;
  delete values.quickFilter;
  delete values.globalFilter;

  if (Object.keys(values).length !== 0) {
    let arrayFields = [];
    let arrayFilters = [];

    let arraySubFields = [];
    let arraySubFilters = [];

    Object.entries(values).forEach((ele) => {
      if (ele[0].includes("2_")) {
        arraySubFields.push(ele[0]);
        arraySubFilters.push(ele[1]);
      } else {
        arrayFields.push(ele[0]);
        arrayFilters.push(ele[1]);
      }
    });

    arraySubFields.forEach((element, index) => {
      element = element.replace("filter_", "");
      element = element.replace("->", ".");

      element = element.replace("2_", "");

      let newField;
      let newFilter;
      if (element === "business_id") {
        newField = `business_id=${arraySubFilters[index]}`;
        subFields = `${subFields}&${newField}`;
      } else if (element === "branch_id") {
        newField = `branch_id=${arraySubFilters[index]}`;
        subFields = `${subFields}&${newField}`;
      } else {
        newField = `searchby2[${index}]=${element}`;
        subFields = `${subFields}&${newField}`;

        newFilter = `search2[${index}]=${arraySubFilters[index]}`;
        subFilters = `${subFilters}&${newFilter}`;
      }
    });

    arrayFields.forEach((element, index) => {
      element = element.replace("filter_", "");
      element = element.replace("->", ".");
      let newField;
      let newFilter;
      if (element === "business_id") {
        newField = `business_id=${arrayFilters[index]}`;
        fields = `${fields}&${newField}`;
      } else if (element === "branch_id") {
        newField = `branch_id=${arrayFilters[index]}`;
        fields = `${fields}&${newField}`;
      } else {
        newField = `searchby[${index}]=${element}`;
        fields = `${fields}&${newField}`;

        newFilter = `search[${index}]=${arrayFilters[index]}`;
        filters = `${filters}&${newFilter}`;
      }
    });

    fields = fields.replace("&", "");
    filters = filters.replace("&", "");
    subFields = subFields.replace("&", "");
    subFilters = subFilters.replace("&", "");
  }

  return {
    searchby: fields === "" && subFields === "" ? "" : `${fields}&${subFields}`,
    search:
      filters === "" && subFilters === "" ? "" : `${filters}&${subFilters}`,
  };
}

/**
 * Builder of url with params for create or update resources
 * @param {object} objectData - Object with field and your values
 * @param {string} stringExtra - Text with params extra
 * @returns string with all params for the URL
 */
function buildUrlParams(objectData, stringExtra) {
  let objectDataToText = encodeQueryData(objectData);
  if (stringExtra !== undefined) {
    objectDataToText = `${objectDataToText}&${stringExtra}`;
  }

  return objectDataToText;
}

/**
 * Formater prices or amounts
 * @param {string} permissions - Role of the user
 * @param {string} infoBusinessUser - Value to ckeck currency
 * @param {number} price - number to format
 * @returns price with format
 */
function formatPrices(displayCurrency, price) {
  const defaultCurrency = themeConfig.currencyDefault;
  const currency = displayCurrency ?? defaultCurrency ?? "USD";
  
  const priceFormated = new Intl.NumberFormat(
    currency === "VES"
      ? "es-VE"
      : currency === "COP"
      ? "es-COP"
      : "en-US",
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      style: "currency",
      currency: currency,
      currencyDisplay: currency === "USD" ? "symbol" : "narrowSymbol",
    }
  ).format(parseFloat(price).toFixed(2));
  
  return priceFormated.replace("Bs.S", "Bs.");
}


/**
 * Mask for prices
 * @param {number} price - number to format
 * @returns price with format
 */
function maskPrice(value) {
  if (value !== null  && value !== undefined) {
    value = value.toString();
    value = value.replace(/([^0-9]+)/g, "");
    value = value.replace(/[.]+/g, "");
    value = value.replace(",", ".");

    if (value !== "") {
      value = parseFloat(value).toFixed(2);
      const amount = new Intl.NumberFormat(undefined, {
        minimumFractionDigits: 2,
      }).format(parseFloat(value) / 100);
      return amount.toString();
    } else {
      return value;
    }
  } else {
    return value;
  }
}

function maskPriceDifferentValues(value) {

  if (value !== null && value !== undefined) {
    value = value.toString();
    value = value.replace(/[^0-9.,]+/g, "");

    const lastCommaPos = value.lastIndexOf(',');
    const lastDotPos = value.lastIndexOf('.');

    if (lastCommaPos > lastDotPos) {
      value = value.replace(/\./g, "").replace(/,/g, ".");
    } else {
      value = value.replace(/,/g, "");
    }

    if (value !== "") {
      value = parseFloat(value).toFixed(2); 

      const amount = parseFloat(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: false 
      });

      return amount;
    } else {
      return value;
    }
  } else {
    return value;
  }
}

function maskPhone(value) {
  if (value !== null) {
    value = value.toString();
    value = value.replace(/([^0-9]+)/g, "");
    value = value.replace(/[.]+/g, "");
    value = value.replace(/[,]+/g, "");

    let num = `${value.substring(0, 3)} ${value.substring(
      3,
      6
    )} ${value.substring(6, 10)}`;
    num = num.trim();
    return num;
  } else {
    return value;
  }
}

/**
 * Get remain time
 * @param {string} deadline - Finish date
 * @returns Object with the remain seconds and remain time
 */
function getRemainTime(deadline) {
  let now = new Date();
  deadline = new Date(deadline);
  let remainTime = differenceInSeconds(deadline, now, ["ceil", "round"]);
  let remainSeconds = differenceInSeconds(deadline, now, ["ceil", "round"]);

  return {
    remainTime,
    remainSeconds,
  };
}

/**
 * Timer for the user session
 * @param {function} modalShow - function to show modal
 * @param {function} notify - function to show notification
 * @param {function} logout - function to logout
 * @returns Object wirh timer update
 */
function timerSession(modalShow, notify, logout) {
  const timerUpdate = setInterval(() => {
    if (window.localStorage.getItem("sessionTime")) {
      let time = getRemainTime(window.localStorage.getItem("sessionTime"));
      if (time.remainTime <= 1) {
        logout();
        notify("ra.notification.time_session", "error");
        clearInterval(timerUpdate);
      } else if (time.remainTime <= 30) {
        modalShow();
      }
      if (
        window.location.href ===
        `${window.location.protocol}//${window.location.host}/#/login`
      ) {
        clearInterval(timerUpdate);
      }
    }
  }, 1000);

  return {
    timerUpdate,
  };
}

/**
 * Convert image to base 64
 * @param {string} url - path image
 * @param {function} setNewImage64 - function to set new image converted
 * @returns setNewImage64
 */
function getBase64Image(url, setNewImage64) {
  fetch(url)
    .then((response) => response.blob())
    .then((myBlob) => {
      let reader = new FileReader();
      reader.onloadend = () => {
        setNewImage64(reader.result);
      };
      reader.readAsDataURL(myBlob);
    });
}

/**
 * Format dates
 * @param {string} date - date to format
 * @param {string} mode - Options: dateWithHours, fullHours, hoursWithoutSeconds, dayAndMonth, weekday, dayAndMonth
 * @returns new date converted
 */
function formatDate(date, mode) {
  let newDate = new Date(date);
  if (typeof date === "string") {
    newDate = new Date(date.slice(0, -5));
  }

  const dateFormatted = newDate.toLocaleDateString();

  const hours =
    newDate.getHours().toString().length === 1
      ? `0${newDate.getHours()}`
      : newDate.getHours();
  const minutes =
    newDate.getMinutes().toString().length === 1
      ? `0${newDate.getMinutes()}`
      : newDate.getMinutes();
  const seconds =
    newDate.getSeconds().toString().length === 1
      ? `0${newDate.getSeconds()}`
      : newDate.getSeconds();

  if (mode) {
    if (mode === "dateWithHours") {
      newDate = `${dateFormatted} ${hours}:${minutes}:${seconds}`;
    } else if (mode === "fullHours") {
      newDate = `${hours}:${minutes}:${seconds}`;
    } else if (mode === "hoursWithoutSeconds") {
      newDate = `${hours}:${minutes}`;
    } else if (mode === "dayAndMonth") {
      newDate = `${newDate.toLocaleDateString(undefined, {
        month: "numeric",
        day: "numeric",
      })}`;
    } else if (mode === "weekday") {
      const uppecaseFirstChart = newDate
        .toLocaleDateString(undefined, { weekday: "long" })
        .charAt(0)
        .toUpperCase();
      const othersCharst = newDate
        .toLocaleDateString(undefined, { weekday: "long" })
        .slice(1);
      newDate = `${uppecaseFirstChart}${othersCharst}`;
    }
  } else {
    newDate = `${dateFormatted}`;
  }

  return newDate;
}

/**
 * Template for terminals
 * @returns excel file
 */
async function excelTemplateForTerminals() {
  const { Workbook } = await import(/* webpackExports: "Workbook" */ "exceljs");
  const { saveAs } = await import(/* webpackExports: "saveAs" */ "file-saver");
  const columns = ["serial", "model", "identifier"];
  const workbook = new Workbook();
  // Create sheet
  const sheet = workbook.addWorksheet("Data", {
    pageSetup: { fitToPage: true, fitToHeight: 25, fitToWidth: 25 },
  });

  // Add titles for columns and styles
  sheet.addRow(columns);
  let headerRow = sheet.getRow(1);

  sheet.columns.forEach((col) => {
    col.width = 25;
    col.style = {
      alignment: { vertical: "middle", horizontal: "center" },
      font: { name: "Arial", size: 12 },
    };
  });
  headerRow.eachCell((cell) => {
    cell.border = {
      top: { style: "dotted", color: { argb: "FFFFFF" } },
      left: { style: "dotted", color: { argb: "FFFFFF" } },
      bottom: { style: "dotted", color: { argb: "FFFFFF" } },
      right: { style: "dotted", color: { argb: "FFFFFF" } },
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.font = {
      name: "Arial",
      color: { argb: "FFFFFF" },
      size: 14,
      bold: true,
    };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "009245" },
      bgColor: { argb: "009245" },
    };
  });

  // Create file downloadable
  workbook.xlsx.writeBuffer().then((data) => {
    let blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "FormatForTerminals.xlsx");
  });
}

async function excelTemplateForProducts() {
  const { Workbook } = await import(/* webpackExports: "Workbook" */ "exceljs");
  const { saveAs } = await import(/* webpackExports: "saveAs" */ "file-saver");
  const columns = ["name", "description","price","quantity"];
  const workbook = new Workbook();
  // Create sheet
  const sheet = workbook.addWorksheet("Data", {
    pageSetup: { fitToPage: true, fitToHeight: 25, fitToWidth: 25 },
  });
  // Add titles for columns and styles
  sheet.addRow(columns);
  let headerRow = sheet.getRow(1);
  sheet.columns.forEach((col) => {
    col.width = 25;
    col.style = {
      alignment: { vertical: "middle", horizontal: "center" },
      font: { name: "Arial", size: 12 },
    };
  });
  headerRow.eachCell((cell) => {
    cell.border = {
      top: { style: "dotted", color: { argb: "FFFFFF" } },
      left: { style: "dotted", color: { argb: "FFFFFF" } },
      bottom: { style: "dotted", color: { argb: "FFFFFF" } },
      right: { style: "dotted", color: { argb: "FFFFFF" } },
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.font = {
      name: "Arial",
      color: { argb: "FFFFFF" },
      size: 14,
      bold: true,
    };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "06A4B4" },
      bgColor: { argb: "06A4B4" },
    };
  });
  // Create file downloadable
  workbook.xlsx.writeBuffer().then((data) => {
    let blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "FormatForProducts.xlsx");
  });
}

async function excelTemplateForProductsStock(data) {
  const { Workbook } = await import(/* webpackExports: "Workbook" */ "exceljs");
  const { saveAs } = await import(/* webpackExports: "saveAs" */ "file-saver");
  const columns = ["id", "name", "quantity"];
  const workbook = new Workbook();
  // Create sheet
  const sheet = workbook.addWorksheet("Data", {
    pageSetup: { fitToPage: true, fitToHeight: 25, fitToWidth: 25 },
  });
  // Add titles for columns and styles
  sheet.addRow(columns);
  let headerRow = sheet.getRow(1);
  sheet.columns.forEach((col) => {
    col.width = 25;
    col.style = {
      alignment: { vertical: "middle", horizontal: "center" },
      font: { name: "Arial", size: 12 },
    };
  });
  headerRow.eachCell((cell) => {
    cell.border = {
      top: { style: "dotted", color: { argb: "FFFFFF" } },
      left: { style: "dotted", color: { argb: "FFFFFF" } },
      bottom: { style: "dotted", color: { argb: "FFFFFF" } },
      right: { style: "dotted", color: { argb: "FFFFFF" } },
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.font = {
      name: "Arial",
      color: { argb: "FFFFFF" },
      size: 14,
      bold: true,
    };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "06A4B4" },
      bgColor: { argb: "06A4B4" },
    };
  });
  const transformedData = data.map(product => ({
      id: product.id,
      name: product.name,
      quantity: 0
  }));
  transformedData.forEach(dataProduct => {
    const values = Object.values(dataProduct);
    sheet.addRow(values);
  });
  // Create file downloadable
  workbook.xlsx.writeBuffer().then((data) => {
    let blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "FormatForProductsStock.xlsx");
  });
}

function passwordGenerator(passwordLength) {
  let characters =
    "abcdefghijklmnopqrstubwsyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890_-&$#@/)(";
  let newPassword = "";
  for (var i = 0; i < passwordLength; i++) {
    newPassword += characters.charAt(
      Math.floor(Math.random() * characters.length)
    );
  }

  return newPassword;
}

function weekDays(translate) {
  return [
    translate("ra.weekDays.sunday"),
    translate("ra.weekDays.monday"),
    translate("ra.weekDays.tuesday"),
    translate("ra.weekDays.wednesday"),
    translate("ra.weekDays.thursday"),
    translate("ra.weekDays.friday"),
    translate("ra.weekDays.saturday"),
  ];
}

function formatNewListProcessor(listProcessor) {
  if(listProcessor.data){
    const processorMap = listProcessor.data.map((processor) => {
      return [processor.name, processor];
    });
  
    return { data: [...new Map(processorMap).values()] };
  }
 
}

const setPaymentMethod = (value, translate) => {
  if (value === "KeyEntry") {
    return translate("ra.fieldsName.transactions.keyEntry");
  } else if (value === "Contactless") {
    return translate("ra.fieldsName.transactions.contactless");
  } else if (value === "Contact") {
    return translate("ra.fieldsName.transactions.contact");
  } else if (value === "Swipe") {
    return translate("ra.fieldsName.transactions.swipe");
  } else if (
    value === "Verification" ||
    value === "Pago móvil" ||
    value === "MobileSale"
  ) {
    return translate("ra.fieldsName.transactions.verification");
  } else if (value === "Transfer") {
    return translate("ra.fieldsName.transactions.transfer"); 
  } else if (value === "Zelle") {
    return translate("ra.fieldsName.transactions.zelle");
  } else if (value === "Cash") {
    return translate("ra.fieldsName.transactions.cash");
  } else if (value === "Card") {
    return translate("ra.fieldsName.transactions.card");
  } else if (value === "CashSale") {
    return translate("ra.fieldsName.transactions.cashSale");
  } else if (value === "DebitSale") {
    return translate("ra.fieldsName.transactions.debitSale");
  } else if (value === "CreditSale") {
    return translate("ra.fieldsName.transactions.creditSale");
  } else if (value === "Change") {
    return translate("ra.fieldsName.transactions.change");
  } else if (value && value.toLowerCase() === "refund") {
    return translate("ra.fieldsName.transactions.refund");
  } else if (value && value.toLowerCase() === "refund creditsale") {
    return `${translate("ra.fieldsName.transactions.refund")} ${translate(
      "ra.fieldsName.transactions.creditSale"
    )}`;
  } else if (value && value.toLowerCase() === "refund debitsale") {
    return `${translate("ra.fieldsName.transactions.refund")} ${translate(
      "ra.fieldsName.transactions.debitSale"
    )}`;
  } else if (value && value.toLowerCase() === "refund cashsale") {
    return `${translate("ra.fieldsName.transactions.refund")} ${translate(
      "ra.fieldsName.transactions.cashSale"
    )}`;
  } else if (value && value.toLowerCase() === "void creditsale") {
    return `${translate("ra.fieldsName.transactions.void")} ${translate(
      "ra.fieldsName.transactions.creditSale"
    )}`;
  } else if (value && value.toLowerCase() === "void debitsale") {
    return `${translate("ra.fieldsName.transactions.void")} ${translate(
      "ra.fieldsName.transactions.debitSale"
    )}`;
  } else if (value && value.toLowerCase() === "void cashsale") {
    return `${translate("ra.fieldsName.transactions.void")} ${translate(
      "ra.fieldsName.transactions.cashSale"
    )}`;
  } else if (
    (value && value.toLowerCase()) === "voided" ||
    (value && value.toLowerCase()) === "void"
  ) {
    return translate("ra.fieldsName.transactions.void");
  } else {
    return value;
  }
};

const setPriceToUsd = (product, listBusiness, role) => {
  const findBusiness = listBusiness.data.find(
    ({ id }) => id === product.business_id
  );
  let parsedParameters = {};
    if (typeof findBusiness.parameters === "string") {
      try {
        parsedParameters = JSON.parse(findBusiness.parameters);
      } catch (e) {
        console.error("Error parsing parameters:", e);
      }
    } else {
      parsedParameters = findBusiness.parameters;
    }
    if(parsedParameters.exchange.base_currency == parsedParameters.exchange.sec_currency){
      return product.price
    }
    const currencyRateBusiness = findBusiness ? parsedParameters.exchange.currency_rate : 1;
  return (product.price / currencyRateBusiness).toFixed(2);
};

const setStatus = (value, translate) => {
  if (value.toLowerCase() === "approved") {
    return {
      name: translate("ra.fieldsName.transactions.approved"),
      color: "primary",
      icon: statusTrueIcon,
    };
  } else if (value.toLowerCase() === "partial approved") {
    return {
      name: translate("ra.fieldsName.transactions.approvedPartial"),
      color: "primary",
      icon: statusTrueIcon,
    };
  } else if (value.toLowerCase() === "voided") {
    return {
      name: translate("ra.fieldsName.transactions.void"),
      color: "error",
      icon: statusFalseIcon,
    };
  } else if (value.toLowerCase() === "refunded") {
    return {
      name: translate("ra.fieldsName.transactions.refund"),
      color: "error",
      icon: statusFalseIcon,
    };
  } else {
    return {
      name: value,
      color: "error",
      icon: statusFalseIcon,
    };
  }
};

const individualFilters = (values) => {
  const serial = `serial=${values.filter_serial ?? ""}`;
  delete values.filter_serial;

  if (values.filter_date) {
    values.filter_from = values.filter_date;
    values.filter_end = values.filter_date;
    delete values.filter_date;
  }

  const dateFrom = `from=${values.filter_from ?? ""}`;
  delete values.filter_from;
  const dateEnd = `end=${values.filter_end ?? ""}`;
  delete values.filter_end;

  return `${serial}&${dateFrom}&${dateEnd}`;
};


const lazyRetry = (componentImport) =>
  new Promise((resolve, reject) => {
    const storageKey = `retry-lazy-refreshed${btoa(componentImport.toString())}`;
    const hasRefreshed = JSON.parse(window.sessionStorage.getItem(storageKey) || 'false');
    componentImport()
      .then((component) => {
        window.sessionStorage.setItem(storageKey, 'false');
        if (component === undefined) {
          window.sessionStorage.setItem(storageKey, 'true');
          return window.location.reload(); // refresh the page
        }
        resolve(component);
      })
      .catch((error) => {
        if (!hasRefreshed) {
          // not been refreshed yet
          window.sessionStorage.setItem(storageKey, 'true');
          window.location.reload();
        }
        reject(error); // Default error behaviour as already tried refresh
      });
  });

export {
  encodeQueryData,
  buildFilter,
  buildUrlParams,
  formatPrices,
  timerSession,
  maskPrice,
  maskPhone,
  formatFilters,
  getBase64Image,
  formatDate,
  excelTemplateForTerminals,
  excelTemplateForProducts,
  excelTemplateForProductsStock,
  passwordGenerator,
  weekDays,
  formatNewListProcessor,
  setPaymentMethod,
  setPriceToUsd,
  setStatus,
  individualFilters,
  maskPriceDifferentValues,
  lazyRetry,
};
